module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"title":"Suas faturas","description":"Acompanhe o estado das suas faturas!","without":"Você não tem nenhuma fatura ainda =/"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Invoice/Invoice.vue
// module id = 114
// module chunks = 0